import { schemes, zSchema } from "../../schema-validation";
import { ETxnSpeed } from "../../transaction-speeds";
import { EDisbursementMethod } from "../../workers-shared";
import { EContractorPaymentStatus } from "../EContractorPaymentStatus";
import { EContractorPaymentType } from "../EContractorPaymentType";

export const contractorPaymentSchema = zSchema.object({
  _id: schemes.mongoObjectId(),
  amount: zSchema.number(),
  approval_required: zSchema.boolean(),
  approved: zSchema.boolean(),
  companyID: schemes.companyID(),
  contractorID: schemes.mongoObjectId(),
  createdAt: zSchema.string(),
  customerAccountID: schemes.uuid().nullish(),
  disbursement: zSchema.object({
    history: zSchema.array(
      zSchema.object({
        status: zSchema.string(),
      })
    ),
    method: zSchema.nativeEnum(EDisbursementMethod),
  }),
  first_name: zSchema.string(),
  group_id: schemes.uuid().optional(),
  last_name: zSchema.string(),
  pay_date: schemes.isoDate(),
  speed: zSchema.nativeEnum(ETxnSpeed).optional(),
  status: zSchema.nativeEnum(EContractorPaymentStatus),
  triggered: zSchema.boolean(),
  triggered_at: zSchema.string().optional(),
  type: zSchema.nativeEnum(EContractorPaymentType),
  updatedAt: zSchema.string(),
  metadata: zSchema.record(zSchema.string(), zSchema.any()),
});
